import lodash from 'lodash'

import dateUtil from '@/utils/dateUtil'
import i18n from '@/utils/i18n'
import { getSubsidiaryTextArray } from '@/api/postman/util'
import { hotbTypes } from '@/utils/locale'
import { getHotbCompanyName, getHotbPremises } from '@/modules/hotb/utils'

export function createScheduleRequest (hotb = {}, remarksListRequest = [], regionName) {
  if (!hotb || !hotb.schedules) return
  const request = extractHotb(hotb, regionName)
  request.remarksList = remarksListRequest
  request.title = request.isHandover ? i18n.t('pdf.title.handover') : i18n.t('pdf.title.takeback')

  return request
}

export function createKeyRequest (hotb = {}, regionName) {
  if (!hotb || !hotb.transactions) return

  const request = extractHotb(hotb, regionName)
  request.transactions = hotb.transactions.filter(item => !(lodash.isEmpty(item.keyItem) && lodash.isEmpty(item.keys) && lodash.isEmpty(item.cards)))

  return request
}

function extractHotb (hotb = {}, regionName) {
  const subsidiaryHtml = lodash.get(hotb, 'physicalSite.subsidiary')
  const subsidiaryArray = getSubsidiaryTextArray(subsidiaryHtml)
  const subsidiary = subsidiaryArray.join(', ')
  return {
    ...hotb,
    isHandover: hotb.type === hotbTypes.HANDOVER,
    building: lodash.get(hotb, 'tenancy.building.fullName') || lodash.get(hotb, 'tenancy.building'),
    subsidiary,
    subsidiaryArray,
    premises: getHotbPremises(hotb),
    schedules: parseSchedules(hotb.schedules || []),
    transactionDate: hotb.scheduledTransactionDate ? dateUtil.format(hotb.scheduledTransactionDate, 'DD MMM YYYY') : dateUtil.format(hotb.transactionDate, 'DD MMM YYYY'),
    transactionTime: hotb.signatures.time || '',
    tenant: getHotbCompanyName(hotb),
    conditionOfPremises: i18n.t(`terms.${regionName}.hotb.conditionOfPremisesDes.${hotb.type}`),
    remark: i18n.t(`terms.${regionName}.hotb.remark.${hotb.type}`, [lodash.get(hotb, 'tenancy.building.fullName', '')]),
  }
}

function parseSchedules (schedules = []) {
  let pageBreakNumber = 0
  return schedules.map(schedule => {
    const fourGrid = lodash.get(schedule, 'files.length') > 2
    let isPageBreakBefore = false
    fourGrid ? pageBreakNumber += 2 : pageBreakNumber++
    if (pageBreakNumber >= 4) {
      isPageBreakBefore = true
      pageBreakNumber = fourGrid ? 2 : 1
    }
    return {
      ...schedule,
      isPageBreakBefore,
    }
  })
}
